import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mlb/react-patterns/components/Button/button.tsx';
import StatusTemplate from 'bdvp-common/src/components/StatusTemplate';

import { SEARCH_ROUTE } from 'bdvp-common/src/utils/constants';

const EmptyReelsPage = ({
    dictionary,
    history,
    searchButtonRef,
}) => {

    const redirectToSearchPage = () => {

        history.push({ pathname: SEARCH_ROUTE });

    };

    return (
        <StatusTemplate
            title={dictionary.empty_reels_title ?? 'Your reels appear to be empty!'}
            message={dictionary.empty_reels_description ?? 'Search for videos to start creating a custom highlight reel.'}
            button={
                <Button
                    size={'md'}
                    label={dictionary.search_now ?? 'Search Now'}
                    handlers={{ onClick: redirectToSearchPage }}
                    ref={searchButtonRef}
                />
            }
        />
    );

};

EmptyReelsPage.propTypes = {
    dictionary: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    searchButtonRef: PropTypes.object,
};

export default EmptyReelsPage;
